export default "__VITE_ASSET__COzDRhHK__"